import * as React from "react"
import { useContext } from "react"
import { Link } from "react-router-dom"
import Slider from "react-slick"
import { Context } from "../../store/store"
import { getText } from "../strapi"

interface SoGehtsProps {
	type?: any
}

const Sogehts: React.FC<SoGehtsProps> = ({ type = "" }) => {
	const { globalState } = useContext(Context)
	var settings = {
		dots: true,
		infinite: false,
		speed: 100,
		slidesToShow: 4,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		// autoplay: true,
		// autoplaySpeed: 4000,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: false,
					dots: false,
					arrows: false,
				},
			},

			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					dots: true,
					arrows: true,
					speed: 300,
					infinite: false,
					slidesToScroll: 1,
				},
			},
		],
	}
	function CustomNextArrow(props) {
		const { className, currentSlide, slideCount, onClick } = props
		return (
			<>
				<div className={className + (currentSlide + 1 < slideCount ? " flex" : " hidden")} onClick={onClick}>
					<svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3 3L19 19L3 35" className="stroke-pink" strokeWidth="6" />
					</svg>
				</div>
			</>
		)
	}

	function CustomPrevArrow(props) {
		const { className, currentSlide, onClick } = props
		return (
			<div className={className + (currentSlide > 0 ? " flex" : " hidden")} onClick={onClick}>
				<svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 3L5 19L21 35" className="stroke-pink" strokeWidth="6" />
				</svg>
			</div>
		)
	}

	return (
		<div className="js-sogehts pt-12 md:pt-24 md:pb-0 pb-12 sm:pb-0 bg-white">
			<div className={"mx-auto max-w-[1324px]"}>
				<h2 className="pb-6 font-AmsiUltra uppercase text-[36px] md:text-[48px] text-blue ">{getText(globalState.strapi.homepage.sogehtsHeadline, "sogehtsHeadline")}</h2>
				<p className="font-AmsiRegular text-blue text-center max-w-[90%] md:max-w-[60%] mx-auto md:mb-[6rem]">Teilnahme ab 18 Jahren. Bitte bewahre den Original-Kassenbon auf. Pro Haushalt und 
					IBAN ist eine Teilnahme möglich. Weitere Informationen findest du in den Teilnahmebedingungen. </p>
				<div className="xl:block hidden">
					<Slider {...settings} className="mx-auto max-w-[1100px] hidden xl:block text-center font-Veener text-[30px] text-white">
						<div>
							<img src={process.env.PUBLIC_URL + "/images/sogehts-first.png"} alt="Schritt 1: TREK Protein Oat Bar kaufen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4 " />
						</div>
						<div>
							<img src={process.env.PUBLIC_URL + "/images/sogehts-second.png"} alt="Schritt 2: Kassenbon fotografieren und hochladen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
						</div>
						<div>
							<img src={process.env.PUBLIC_URL + "/images/sogehts-third.png"} alt="Schritt 3: Formular ausfüllen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
						</div>
						<div>
							<img src={process.env.PUBLIC_URL + "/images/sogehts-four.png"} alt="Schritt 4: Cashback erhalten" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
						</div>
					</Slider>
				</div>
				<div className="grid grid-cols-2 xl:hidden mt-12 gap-y-8">
					<div>
						<img src={process.env.PUBLIC_URL + "/images/sogehts-first.png"} alt="Schritt 1: TREK Protein Oat Bar kaufen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4 " />
					</div>
					<div>
						<img src={process.env.PUBLIC_URL + "/images/sogehts-second.png"} alt="Schritt 2: Kassenbon fotografieren und hochladen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
					</div>
					<div>
						<img src={process.env.PUBLIC_URL + "/images/sogehts-third.png"} alt="Schritt 3: Formular ausfüllen" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
					</div>
					<div>
						<img src={process.env.PUBLIC_URL + "/images/sogehts-four.png"} alt="Schritt 4: Cashback erhalten" className="z-2 relative mx-auto w-full max-w-[226px] sm:max-w-[276px] mb-4" />
					</div>
					</div>

				<div className="px-4 xl:px-12 max-w-[800px] mt-6 md:mt-24">
					<p className="small text-blue">
						** Gültig für den Kauf eines TREK PROTEIN OAT BAR Multipacks (150 g) im stationären Handel. </p>
						<p className="small text-blue pl-2 md:pl-3">Käufe über Online-Shops sind von der Aktion ausgeschlossen.  </p>
				</div>
			</div>
		</div>
	)
}

export default Sogehts
